import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExtensionOnboardingPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ExtensionOnboardingPage" */ './Container'),
  'page'
);
